import {requestWithToken} from "../apiConfigs/request";

export const fetchAppliedJobsList = (query) => {
  return requestWithToken({
    url: `/applied-jobs${query}`,
    method: 'GET'
  });
}
